<p-dropdown (onChange)="moveCard($event.value)" [options]="statuses" [(ngModel)]="status"
	placeholder="Select a Status" optionLabel="name">
	<ng-template let-item pTemplate="selectedItem">
		<div class="selected-item">
			{{item.name}}
		</div>

	</ng-template>
</p-dropdown>
